/* global axios */
import ApiClient from './ApiClient';

class FlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  clone(id) {
    return axios.post(`${this.url}/${id}/clone`);
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }

  deactivate(id) {
    return axios.post(`${this.url}/${id}/deactivate`);
  }

  getExecutions(id) {
    return axios.get(`${this.url}/${id}/executions`);
  }
}

export default new FlowsAPI();
